<template>
  <div class="mb-8">
    <TransactionEditModalProvider :transaction="edit_transaction"
                                  position="absolute"
                                  @finished="handleTransactionUpdate"
                                  @close="edit_transaction = null"/>
    <div v-if="loading" class="flex justify-center">
      <font-awesome-icon class="text-center text-lg text-primary" icon="circle-notch" spin/>
    </div>
    <template v-else>
      <div>
        <TransactionItem v-for="(transaction,i) in transactions" :key="i"
                         :transaction="transaction"
                         :layout="'default'"
                         @edit="edit_transaction = $event"/>
      </div>
      <div class="mt-2"
           v-show="current_page < pages_length || more_loading">
                <span v-if="!more_loading"
                      class="text-2sm text-text-ternary cursor-pointer mt-8
                      transition duration-200
                      border-b border-dashed border-text-ternary
                      hover:text-red hover:border-red"
                      @click="showMore">{{ $t('showMore') }}</span>
        <font-awesome-icon v-else class="text-primary" icon="circle-notch" spin/>
      </div>
    </template>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import TransactionEditModalProvider
  from "@/components/common/Transaction/TransactionEditModal/TransactionEditModalProvider";
import TransactionItem from "@/components/common/Transaction/TransactionItem/TransactionItem";

export default {
  name: "CalendarInfoTransactions",
  components: {TransactionItem, TransactionEditModalProvider},
  data() {
    return {
      edit_transaction: null
    }
  },
  computed: {
    ...mapState('space/calendar', {
      date: state => state.dateSelected,
      transactions: state => state.transactions.data,
      loading: state => state.transactions.dirty,
      more_loading: state => state.transactions.moreLoading,
      current_page: state => state.transactions.pagination.current_page,
      pages_length: state => state.transactions.pagination.pages
    }),
  },
  methods: {
    ...mapActions('space/calendar', ['fetchCalendar', 'fetchTransactions', 'fetchMoreTransactions']),
    ...mapMutations('space/calendar', ['setTransactionsPage', 'clearTransactions']),
    async showMore() {
      this.setTransactionsPage(this.current_page + 1)
      try {
        await this.fetchMoreTransactions();
      } catch (err) {
        console.error(err)
      }
    },
    handleTransactionUpdate() {
      this.fetchCalendar();
      this.fetchTransactions();
    }
  },
  watch: {
    date: {
      immediate: true,
      handler(newVal) {
        this.clearTransactions();
        if (newVal) {
          this.fetchTransactions();
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        showMore: 'Show more'
      },
      ru: {
        showMore: 'Показать ещё'
      },
    }
  }
}
</script>